import React from "react";
import { useTranslation } from "react-i18next";
import { FaShieldAlt, FaClock, FaRunning, FaUserFriends, FaUserCog, FaCode, FaHardHat, FaCar, FaHeartbeat } from "react-icons/fa";
import { GiRunningShoe } from "react-icons/gi";
import { MdFamilyRestroom, MdHealthAndSafety, MdOutlineLocalLibrary } from "react-icons/md";

export const usePersonaData = () => {
    const { t } = useTranslation("Persona");

    const iconMap: Record<string, React.ReactNode> = {
        family: <MdFamilyRestroom size={32} color="#9333EA" />,
        amateur: <FaRunning size={32} color="#3B82F6" />,
        pro: <GiRunningShoe size={32} color="#0ea5a4" />,
        caregiver: <FaUserFriends size={32} color="#22C55E" />,
        women: <MdHealthAndSafety size={32} color="#EC4899" />,
        hr: <FaUserCog size={32} color="#F97316" />,
        driver: <FaCar size={32} color="#7C3AED" />,
        industrial: <FaHardHat size={32} color="#DC2626" />,
        developer: <FaCode size={32} color="#14B8A6" />,
        school: <MdOutlineLocalLibrary size={32} color="#0EA5A4" />,
        chronic: <FaHeartbeat size={32} color="#EF4444" />,
        medical: <GiRunningShoe size={32} color="#8b5cf6" />,
        insurance: <FaShieldAlt size={32} color="#64748b" />,
        shift: <FaClock size={32} color="#f59e0b" />,
    };

    const personas = Array.from({ length: 14 }, (_, i) => ({
        icon: iconMap[t(`personas.${i}.iconKey`)],
        title: t(`personas.${i}.title`),
        subtitle: t(`personas.${i}.subtitle`),
        description: t(`personas.${i}.description`),
        recommendedProduct: t(`personas.${i}.recommendedProduct`),
        color: t(`personas.${i}.color`),
        category: t(`personas.${i}.category`),
        benefits: t(`personas.${i}.benefits`, { returnObjects: true }) as string[],
    }));

    return { personas };
};